import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
// CSS
import "../../css/header/main-nav.css";

// Utils
import { userIsReviewer } from "../../utils/reviewerHelpers";

const translationKey = "app";

class MainNav extends Component {
	render() {
		const { translationsLoading, translations, reviewer } = this.props;

		return reviewer && !translationsLoading ? (
			<nav>
				<ul>
					<li>
						<NavLink to={"/"} exact>
							{translations.sections[translationKey].home}
						</NavLink>
					</li>
					<li>
						<NavLink to={"/reviewer"}>
							{translations.sections[translationKey].profile}
						</NavLink>
					</li>
					{userIsReviewer(reviewer.user) && (
						<li>
							<NavLink to={"/reviews"}>
								{translations.sections[translationKey].reviews}
							</NavLink>
						</li>
					)}
					<li>
						<NavLink to={"/training"}>
							{translations.sections[translationKey].training}
						</NavLink>
					</li>
					<li>
						<NavLink to={"/change-password"}>
							{translations.sections[translationKey].change_password_nav}
						</NavLink>
					</li>
					<li>
						<NavLink className="link-section" to={`/reviewer/logout`}>
							{translations.sections[translationKey].logout}
						</NavLink>
					</li>
				</ul>
			</nav>
		) : (
			<div className="blank-nav" />
		);
	}
}

const mapStateToProps = state => {
	return {
		translationsLoading:
			state.translations.isLoading[translationKey] === undefined
				? 1
				: state.translations.isLoading[translationKey],
		translations: state.translations.translations,
		reviewer: state.user.reviewer
	};
};

export default withRouter(connect(mapStateToProps)(MainNav));



// WEBPACK FOOTER //
// ./src/components/header/MainNav.js